"use client"

import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import  DrawerContainer, { DrawerOption } from "@/components/DrawerContainer";
import { uid } from "./functions";


const DrawerContext = createContext<{
  openDrawer: ({ id, title, content , anchor }: { id?: string; title: string | JSX.Element; content: React.ReactNode , anchor?:  "top" | "left" | "bottom" | "right" }) => void;
  closeDrawer: (drawerid: string) => void;
  isAnyDrawerOpen: () => boolean;
  closeLastDrawer: () => void;
}>({ openDrawer: () => {}, closeDrawer: () => {}, isAnyDrawerOpen: () => false, closeLastDrawer: () => {} });

export function useDrawer() {
  return useContext(DrawerContext);
}
export default function DrawerProvider({ children }: { children: React.ReactNode }) {
  const [Drawers, setDrawers] = useState<DrawerOption[]>([{content : <div></div> , open : false , title: "" , id:uid()  }]);
  const prevDrawers = Drawers
  const openDrawer = ({ id, title, content , anchor }: { id?: string; title: string | JSX.Element; content: React.ReactNode  , anchor? :  "top" | "left" | "bottom" | "right" }) => {
    let newDrawer: DrawerOption = { title: title, content: content, open: false, id: id ?? uid() , anchor : anchor };
    
    setDrawers((prevDrawers) => {
      const updatedDrawers = [...prevDrawers, newDrawer];
  
      setTimeout(() => {
        const updatedDrawersWithOpen = updatedDrawers.map((drawer) =>
          drawer.id === newDrawer.id ? { ...drawer, open: true } : drawer
        );
  
        setDrawers(updatedDrawersWithOpen);
      }, 100);
  
      return updatedDrawers;
    });
  };

  const closeDrawer = (drawerid: string) => {
    
    setDrawers((prevDrawers) => {
      const updatedDrawers = prevDrawers.map((drawer) =>
        drawer.id === drawerid ? { ...drawer, open: false } : drawer
      );
      setDrawers([...updatedDrawers]);
      setTimeout(() => {
        setDrawers((prevDrawers) => prevDrawers.filter((drawer) => drawer.id !== drawerid));
      }, 250);
      return updatedDrawers;
    });
  };
 
  

  const isAnyDrawerOpen = () => {
    return Drawers.filter((d)=> d.open==true).length>0
  };

  const closeLastDrawer = () => {
    setDrawers((prevDrawers) => {
      const updatedDrawers = prevDrawers.map((drawer) =>
        drawer.id === Drawers[0].id ? { ...drawer, open: false } : drawer
      );
      setDrawers([...updatedDrawers]);
      setTimeout(() => {
        setDrawers([]);
      }, 250);
      return updatedDrawers;
    });
   
  };

  const contextValue = useRef({ openDrawer, closeDrawer, isAnyDrawerOpen, closeLastDrawer });

  return (
    <DrawerContext.Provider value={contextValue.current}>
      {children}
      {Drawers.map((drawer, index) => (
        <DrawerContainer key={index} {...drawer} onClose={() => closeDrawer(drawer.id)} />
      ))}
    </DrawerContext.Provider>
  );
}